import { lazy, Suspense, type FC, type ComponentProps } from 'react';
import { LoadingComponent } from '../../../components/global/LoadingComponent.tsx';
import { ErrorBoundary } from 'dibs-error-tools/ErrorBoundary.tsx';

const PdpSharedShippingAndReturnsModalLazy = lazy(
    () =>
        import(
            /* webpackChunkName: "PdpSharedShippingAndReturnsModal" */
            './PdpSharedShippingAndReturnsModal.tsx'
        )
);

const PdpSharedShippingAndReturnsModalLoader: FC<
    ComponentProps<typeof PdpSharedShippingAndReturnsModalLazy>
> = props => {
    if (!props.isOpened) {
        return null;
    }

    return (
        <ErrorBoundary fallback={() => null}>
            <Suspense fallback={<LoadingComponent />}>
                <PdpSharedShippingAndReturnsModalLazy {...props} />
            </Suspense>
        </ErrorBoundary>
    );
};

export { PdpSharedShippingAndReturnsModalLoader };
